import { AlertTitle } from '@mui/material';
import React from 'react'

const DefaultErrorDetails = ({ error }) => {
    const showMessage = error?.message && error?.message !== error?.title;
    const title = error?.title;
    return (
        <div>
            <AlertTitle>{title}</AlertTitle>
            {showMessage && <p>{error.message}</p>}
            {error?.defaultMessage ? (
                <ul>
                    <li>{error?.defaultMessage}</li>
                </ul>
            ) : null}
            {!showMessage && !error?.defaultMessage && <p>An unknown error occurred.</p>}
        </div>
    );
};

export default DefaultErrorDetails;
